import { createAction, props } from '@ngrx/store';

import type { MGMBuyerInfo } from '../model';

const MEMBER_GET_MEMBER_ACTION_PREFIX = '[member-get-member]';

export const loadMGMPingScriptAction = createAction(
  `${MEMBER_GET_MEMBER_ACTION_PREFIX} Load MemberGetMember ping script`
);

export const memberGetMemberSaleSubmit = createAction(
  `${MEMBER_GET_MEMBER_ACTION_PREFIX} Submit sale`,
  props<{ payload: MGMBuyerInfo }>()
);

export const setMGMSaleIdAction = createAction(
  `${MEMBER_GET_MEMBER_ACTION_PREFIX} Set MemberGetMember sale id`,
  props<{ saleId: string }>()
);

export const setMGMCustomerDetails = createAction(
  `${MEMBER_GET_MEMBER_ACTION_PREFIX} Customer Details`,
  props<{ customerName: string; customerEmail: string }>()
);
